/* eslint-disable */

import { isInternalPlatformURL } from "./authUtils";

export function parameterize(inputText) {
  return inputText.toLowerCase().replace(/ /g, '_');
}

export function humanize(inputText) {
  return inputText.replace('_', ' ').toUpperCase();
}

export function splitToWords(inputText) {
  return inputText.replace(/_/g, ' ');
}

export function CapitalizeAllWords(inputText) {
  let result = '';
  let parts = inputText.split(' ');
  result = CapitalizeFirstLetter(parts[0]);
  for (var i = 1; i < parts.length; i++) {
    result += ' ' + CapitalizeFirstLetter(parts[i]);
  }
  return result;
}

export function CapitalizeFirstLetter(inputText) {
  inputText = !!inputText ? inputText.toLowerCase() : null;
  return !!inputText
    ? inputText.charAt(0).toUpperCase() + inputText.slice(1)
    : null;
}

export function handleApiErrors(response) {
  if (!response.ok) throw Error(response.statusText);
  return response;
}

export function action(type, payload = {}) {
  return { type, ...payload };
}

export const rem = (pixels) => {
  return pixels / 16 + 'rem';
};

export const getCurrencyFormattedAmount = (
  amount,
  defaultEmptyText = 'NA',
  currency = 'INR',
  currencyDisplay = 'symbol',
  locale = 'en-IN'
) => {
  if (amount == '0') return defaultEmptyText;
  if (!!amount || amount == 0) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(amount);
  }
  return defaultEmptyText;
};

export const getFormattedAmount = (amount, maximumFractionDigits = 6) => {
  if (amount !== undefined && amount !== null) {
    return `₹ ${Number(amount).toLocaleString('en-IN', {
      maximumFractionDigits: maximumFractionDigits,
    })}`;
  }
  return '';
};

export const getUnique = (array) => [...new Set(array)];

export const capitalizeUnderscored = (str = '') => {
  var frags = str.split('_');
  for (let i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
};

export const stopPropagation = (event) => (callback) => {
  event.persist();
  event.stopPropagation();
  if (typeof callback === 'function') {
    callback();
  }
};

export const hasErrors = (fieldsError) => {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
};

export const JSONToQueryStringForOldRuby = (obj, prefix) => {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      let k = prefix ? prefix + '[]' : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? JSONToQueryStringForOldRuby(v, k)
          : encodeURIComponent(k) + '=' + encodeURIComponent(v)
      );
    }
  }
  return str.join('&');
};

export const JSONToQueryString = (obj, prefix) => {
  let str = [],
    p;
  for (p in obj) {
    if (obj.hasOwnProperty(p)) {
      let k = prefix ? prefix + '[' + p + ']' : p,
        v = obj[p];
      str.push(
        v !== null && typeof v === 'object'
          ? JSONToQueryString(v, k)
          : encodeURIComponent(k) + '=' + encodeURIComponent(v)
      );
    }
  }
  return str.join('&');
};

export const queryStringToJSON = (qs) => {
  let pairs = qs.split('&');
  let result = {};
  pairs.forEach(function (p) {
    let pair = p.split('=');
    let key = pair[0];
    let value = decodeURIComponent(pair[1] || '');

    if (result[key]) {
      if (Object.prototype.toString.call(result[key]) === '[object Array]') {
        result[key].push(value);
      } else {
        result[key] = [result[key], value];
      }
    } else {
      result[key] = value;
    }
  });

  return JSON.parse(JSON.stringify(result));
};

export const formatCurrency = (
  amount,
  currency = 'INR',
  adjustDecimal = false
) => {
  if (adjustDecimal) {
    return `${currency} ${amount.toFixed(2) || 0}`;
  }
  return `${currency} ${amount || 0}`;
};

export const floorFigureAmount = (figure, decimals) => {
  if (!decimals) decimals = 2;
  var d = Math.pow(10, decimals);
  return (parseInt(figure * d) / d).toFixed(decimals);
};

export const prettifyCamelCase = (value = '') => {
  let output = '';
  let len = value.length;
  let char;
  let previousChar;
  for (let i = 0; i < len; i++) {
    char = value.charAt(i);
    previousChar = i > 0 ? value.charAt(i - 1) : null;
    if (i == 0) {
      output += char.toUpperCase();
    } else if (
      char !== char.toLowerCase() &&
      char === char.toUpperCase() &&
      previousChar == previousChar.toLowerCase()
    ) {
      output += ' ' + char;
    } else if (char == '-' || char == '_') {
      output += ' ';
    } else {
      output += output[i - 1] == ' ' ? char.toUpperCase() : char;
    }
  }
  return output;
};

export const getFormatedDate = (value) => {
  const date = new Date(value);
  return date;
};

export const filterDataForDateRange = ({
  data = [],
  dateField = 'date',
  startDate,
  endDate,
}) => {
  const tempData = data.filter((obj) =>
    checkDateForDateRange(obj[dateField], startDate, endDate)
  );

  return tempData;
};

export const getMonthsToYear = (months = 0, defaultEmptyText = 'NA') => {
  const year = Math.floor(months / 12);
  const month = months % 12;

  let returnVal = '';

  if (year) {
    returnVal += year + ' Year';
    if (year > 1) returnVal += 's';
  }
  if (returnVal) returnVal += ' ';
  if (month) {
    returnVal += month + ' Month';
    if (month > 1) returnVal += 's';
  }
  if (returnVal === '') returnVal = defaultEmptyText;
  return returnVal;
};
export const getDaysSuffix = (day = 0, defaultEmptyText = 'NA') => {
  let returnValue = '';
  if (!day) returnValue = defaultEmptyText;
  else {
    returnValue = day + ' day';
    if (day > 1) returnValue += 's';
  }
  return returnValue;
};
export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const getContainer = (id) => {
  const appId = process.env.REACT_APP_MICROFRONTEND_MODULE_NAME;
  return document.getElementById(id || appId);
};

export function isEmptyObject(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return false; // Not a valid object
  }
  return Object.keys(obj).length === 0;
}
export const getErrorMessageFromError = (e) => {
  if (e instanceof Error) return e.message;
  return '' + e;
};

export const getFDsErrorMessageFromError =(e)=>{
  const error=getErrorMessageFromError(e)
    const errorObject = JSON.parse(error.error.match(/\[([^\]]+)\]/)[1]);
    return errorObject;
}

export function cleanFileName(fileName) {
  return fileName
    .replace(/\.[^/.]+$/, '') // to get rid of the extension
    .replace(/[^0-9a-z]/gi, ''); // to get rid of the non-alphanumeric characters
}

export function getExtension(fileName) {
  return fileName.split('.').pop() || '';
}


export function extractPANFromGSTIN(gstin) {
  if (gstin?.length >= 15) {
      // Extract PAN from the 4th to 12th characters (9 characters in total)
      const pan = gstin.substring(2, 12);
      return pan;
  } else {
      return null;
  }
}

export const getAppSource = () => `${isInternalPlatformURL() ? 'InternalApp' : 'BizongoApp'}`;
export const getJwtKeySourceKey = () => `jwt_token_${getAppSource()}`;

export const formatDate = (dateArray) => {
  let [year, month, day] = dateArray;
  
  let date = new Date(year, month - 1, day);

  function getDaySuffix(day) {
      if (day >= 11 && day <= 13) return "th";
      switch (day % 10) {
          case 1: return "st";
          case 2: return "nd";
          case 3: return "rd";
          default: return "th";
      }
  }

  let dayWithSuffix = day + getDaySuffix(day);
  
  let monthAbbr = date.toLocaleDateString("en-GB", { month: "short" });

  return `${dayWithSuffix} ${monthAbbr} ${year}`;
}
